import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { DropdownSelect } from '../dropdown-select/DropdownSelect';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { InteroperableDataService } from '../../services/interoperableDataService';

export const SelectDepartment = ({ selectedDepartment, onChange, getData, disabled, maskLabel }) => {
  const { translate: t } = useDictionaryTranslation();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);

  const selectDepartment = item => {
    const department = departments.find(d => d._id === item?.value);
    onChange(department);
  };

  const getDepartments = useCallback(async search => {
    setLoading(true);
    try {
      const params = { search, isServiceCreation: true };
      const { departments: departmentsList } = await getData(params);
      setDepartments(departmentsList);
    } catch (error) {
      setDepartments([]);
    } finally {
      setLoading(false);
    }
  }, [getData]);

  const getOptionData = useCallback(department => {
    return {
      value: department._id,
      label: department.state_name,
    };
  }, []);

  return (
    <DropdownSelect
      placeholderText={t('departmentPlaceholder')}
      isLoading={loading}
      onChange={selectDepartment}
      options={departments}
      value={selectedDepartment}
      onSearch={getDepartments}
      getOptionData={getOptionData}
      disabled={disabled}
      maskLabel={maskLabel}
    />
  );
};

SelectDepartment.propTypes = {
  selectedDepartment: PropTypes.shape({
    iso_state_code: PropTypes.string,
    state_name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  getData: PropTypes.func,
  disabled: PropTypes.bool,
  maskLabel: PropTypes.func,
};

SelectDepartment.defaultProps = { 
  getData: InteroperableDataService.getDepartments,
 }